import styled, { css } from 'styled-components';
import { TypographyText } from './Typography';
import { ITypography, typographyProps } from './types';

interface IText extends ITypography {
  fontSize?: number;
  lineHeight?: number;
}

export const Text = styled(TypographyText)<IText>`
  ${typographyProps};
  display: block;
  font-size: 14px;
  line-height: 20px;

  ${({ fontSize }) =>
    fontSize &&
    css`
      font-size: ${fontSize}px;
    `}

  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${lineHeight}px;
    `}
`;

export const SmallText = styled(Text)`
  font-size: 12px;
  line-height: 16px;
`;
